// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"f3d22d60","outerContainer":"_5e93dc28","secondaryToolbar":"_1169c864","doorHangerRight":"_011802fc","toolbarContainer":"_964b1aea","toolbarViewerMiddle":"_1dff4301","progressBar":"bbb13a38","back-to-application":"_7dfe1001","history":"_27d7f682","modal":"_9aef638d","item":"b75d3ea2","pure":"_5e477cc4","info":"f51a214f","sub":"e218968e","light":"_1d0091df","load":"f927f100","loader":"_71087c01"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Charts/HistoryWrapper/styles.styl
// module id = 5189
// module chunks = 39